<template>
    <v-container class="d-flex align-center justify-center fill-height">
      <v-card class="pa-4" max-width="400">
        <v-card-title>
          <v-img src="@/assets/logo.png" alt="E-Photo Logo" max-height="60"></v-img>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-alert v-if="message" type="success">{{ message }} <a style="color:white" href="/EPeople/">Click here to login...</a></v-alert>
          <v-alert v-if="error" type="error">{{ error }}</v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'ConfirmEmail',
    data() {
      return {
        message: null,
        error: null,
      };
    },
    async created() {
      const token = this.$route.params.token;
      try {
        const response = await axios.get(process.env.VUE_APP_SERVER3 + `/confirm/${token}`);
        this.message = response.data.message;
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.message 
          ? error.response.data.message 
          : 'Confirmation failed';
        console.error(error);
      }
    },
  };
  </script>
  
  <style scoped>
  .fill-height {
    height: 100vh;
  }
  </style>
  